import dayjs from 'dayjs';

export default {
  methods: {
    dateFormat(date, type = 'dateTime') {
      const format = type === 'dateTime' ? 'DD/MM/YYYY HH:mm:ss' : 'DD/MM/YYYY';
      return dayjs(date).format(format);
    },
  },
};
